import { Action } from '../../../api/newsfeed.types'
import { ActionsItemAction } from './actions.item.types'

export const actionsItemRequestAction = (params: { action_id: number }): ActionsItemAction => ({ type: 'ACTIONS_ITEM_REQUEST', params })
export const actionsItemSuccessAction = (action: Action): ActionsItemAction => ({ type: 'ACTIONS_ITEM_SUCCESS', params: action })
export const actionsItemFailureAction = (error?: any): ActionsItemAction => ({ type: 'ACTIONS_ITEM_FAILURE', params: error })